import City from '../models/city.model';
import Address from "../models/address.model";

/**
 * Read a city retrieved from the backend.
 * @param {Object} o
 * @return {City}
 */
function readCity(o) {
  const address = new Address('', '', o.name, {lat: o.latitude, lon: o.longitude});
  return new City(
    o.id,
    o.name,
    o.locations,
    address,
    o.is_default,
    o.services,
    o.other_services,
    o.url,
  );
}

export {
  readCity
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/city.serializer.js